import http from '../http';
import { errorPayload, successPayload } from '@/services/formatter';

async function getActiveFeedTypes() {
  try {
    const response = await http({
      url: `/feeds/types/tenant/active`,
      method: 'get',
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function getActiveFeeds() {
  try {
    const response = await http({
      url: `/feeds/tenant/active`,
      method: 'get',
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function getActiveManualOddsFeeds() {
  try {
    const response = await http({
      method: 'GET',
      url: `/feeds/manual-odds/tenant/active`,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function getActiveOddsSchemes() {
  try {
    const response = await http({
      method: 'GET',
      url: `/feeds/odds-scheme/tenant/active`,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function getActiveResolveFormulaFeeds() {
  try {
    const response = await http({
      method: 'GET',
      url: `/feeds/resolve-formula/tenant/active`,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

export {
  getActiveFeeds,
  getActiveFeedTypes,
  getActiveManualOddsFeeds,
  getActiveOddsSchemes,
  getActiveResolveFormulaFeeds,
};
